import { thresholdInstruction } from "@constants/instructionConstants";
import { virtualAssistanceContrastSensitivityThresholdConfig } from "@constants/virtualAssistanceConstants";
import {
  AvailablePreTestConfigurationOptions,
  TestType,
  EyeType,
  TestConfiguration,
  TestCategory,
  WaitDuration,
  TestUIConfiguration,
} from "types/testTypes";

import { CATEGORY_VERSION_MAP, TEST_TYPE_VERSION_MAP } from "../versionConstants";
import {
  AVAILABLE_EYE_OPTIONS_BINOCULAR_MONOCULAR,
  AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
} from "../configurationHelperConstants";

export const availableContrastSensitivityTestConfigurationOptions: AvailablePreTestConfigurationOptions =
  {
    testTypes: {
      configurationFieldName: "testType",
      validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.ContrastSensitivity],
      isMandatory: true,
      choices: [
        { validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.Threshold], value: TestType.Threshold },
        { validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.Ascending], value: TestType.Ascending },
        {
          validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.PelliRobson],
          value: TestType.PelliRobson,
        },
      ],
    },
    eyeConfigurationOptions: { ...AVAILABLE_EYE_OPTIONS_BINOCULAR_MONOCULAR },
    languageOptions: null,
    virtualAssistantOptions: { ...AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS },
    testSpeedOptions: null,
  };

export const contrastSensitivityTestConfiguration: TestConfiguration = {
  name: TestCategory.ContrastSensitivity,
  testType: TestType.Threshold,
  eyeConfiguration: {
    eyeType: EyeType.BothEye,
    isCalibrationNeeded: false,
    autoPauseForGaze: false,
    isTwoScreenFixationEnabled: true,
    isBackToBackEyeTest: false,
  },
  testSpeed: WaitDuration.Standard,
  testLanguage: null,
  virtualAssistanceConfig: virtualAssistanceContrastSensitivityThresholdConfig,
  isPressToStartEnabled: false,
};

export const contrastSensitivityUIConfiguration: TestUIConfiguration = {
  showProgressBar: true,
  instructions: thresholdInstruction,
};
